import * as React from "react";
import { connect } from "react-redux";

import {
  ProgressBar as ProgressBarComponent,
  ProgressBarProps,
} from "../../components/ProgressBar/ProgressBar";

class ProgressBar extends React.Component<ProgressBarProps> {
  render() {
    return <ProgressBarComponent {...this.props} />;
  }
}

export default connect(null, {})(ProgressBar);
